<template>
    <el-container class="container" :class="scale ? 'scale' : ''">
        <el-aside width="220px">
            <el-scrollbar style="height: 100%">
                <el-menu :default-active="$route.path" :router="true" text-color="#fff" background-color="#2f4050"
                         :unique-opened="true">
                    <el-menu-item class="sidebar-header">
<!--                        <img class="logo" src="../assets/logo.png" alt="Logo" height="25">-->
                        <el-dropdown trigger="click" class="pull-right" @command="dropdownClick">
                            <div class="el-dropdown-link">
                                <div style="overflow: hidden;text-overflow: ellipsis;width: 158px;display: inline-block;text-align:right">{{$root.alias}}</div>
                                <i class="el-icon-caret-bottom el-icon--right"></i>
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="modifyPass">修改密码</el-dropdown-item>
                                <el-dropdown-item command="logout">退出</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-menu-item>
                    <template v-for="(menu, i) in menus">
                        <el-menu-item v-if="!menu.child" :key="i" :index="menu.path">
                            <i :class="menu.icon"></i>
                            <span slot="title">{{menu.name}}</span>
                        </el-menu-item>
                        <el-submenu v-else :key="i" :index="'menu' + i">
                            <template slot="title">
                                <i :class="menu.icon"></i>
                                <span slot="title">{{menu.name}}</span>
                            </template>
                            <el-menu-item v-for="(sub, j) in menu.child" :key="'c_' + j" :index="sub.path">
                                <span slot="title">{{sub.name}}</span>
                            </el-menu-item>
                        </el-submenu>
                    </template>
                </el-menu>
            </el-scrollbar>
        </el-aside>
        <el-container class="container" style="padding: 10px 10px 10px 20px">
            <el-main>
                <el-scrollbar style="height: 100%">
                    <router-view></router-view>
                </el-scrollbar>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    export default {
        data() {
            return {
                scale: false,
                menus: []
            }
        },
        beforeMount() {
            let width = document.documentElement.clientWidth;
            if (width > 1700) {
                this.scale = false;
            }
        },
        mounted() {
            if (this.$root.isAdmin) {
              if (this.$root.isSupper) {
                this.menus = [
                  {
                    name: "API短信管理", icon: "el-icon-message", child: [
                      {name: "短信下行", path: "/downlogs"},
                      {name: "上行短信", path: "/uplogs"},
                      {name: "互动管理", path: "/autoreplies"},
                    ]
                  },
                  {
                    name: "API视频短信管理", icon: "el-icon-message", child: [
                      {name: "视频短信下行", path: "/video/logs"}
                    ]
                  },
                  {
                    name: "API国际短信管理", icon: "el-icon-message", child: [
                      {name: "国际短信下行", path: "/isms/logs"}
                    ]
                  },
                  {
                    name: "API语音短信管理", icon: "el-icon-message", child: [
                      {name: "语音短信下行", path: "/voice/logs"}
                    ]
                  },
                  {
                    name: "工单管理", icon: "el-icon-picture-outline", child: [
                      {name: "短信模板", path: "/templates"},
                      {name: "短信工单", path: "/jobs"},
                      {name: "视频短信模板", path: "/video/templates"},
                      {name: "视频短信工单", path: "/video/jobs"},
                      {name: "国际短信模板", path: "/isms/templates"},
                      {name: "国际短信工单", path: "/isms/jobs"},
                      {name: "语音短信模板", path: "/voice/templates"},
                      {name: "语音短信工单", path: "/voice/jobs"},
                    ]
                  },
                  {
                    name: "部门管理", icon: "el-icon-user", child: [
                      {name: "部门列表", path: "/customers"},
                      {name: "业务管理", path: "/businesses"},
                    ]
                  },
                  {
                    name: "运维工具", icon: "el-icon-star-on", child: [
                      {name: "敏感词", path: "/sensitives"},
                      {name: "黑名单", path: "/blacklist"},
                      {name: "名单管理", path: "/namelist"},
                      {name: "数据统计", path: "/summary"},
                      {name: "报告推送", path: "/pushreport"},
                      {name: "消费明细", path: "/dashboard/consume"},
                      {name: "统计面板", path: "/dashboard/summary"},
                    ]
                  },
                  {
                    name: "运营商管理", icon: "el-icon-position", child: [
                      {name: "短信通道", path: "/channels"},
                      {name: "路由配置", path: "/routes"},
                      {name: "通道统计", path: "/channelsummary"},
                    ]
                  },
                  {
                    name: "系统工具", icon: "el-icon-setting", child: [
                      {name: "下载管理", path: "/downloads"},
                      {name: "通道监控", path: "/monitor"},
                      {name: "短信测试", path: "/test"},
                      {name: "全局配置", path: "/config/global"},
                      {name: "价格管理", path: "/config/price"},
                      {name: "错误码", path: "/config/errorcode"},
                      {name: "流控规则", path: "/rates"},
                      {name: "流控全局规则", path: "/rateglobal"},
                    ]
                  }
                ];
              } else {
                this.menus = [
                  {
                    name: "API短信管理", icon: "el-icon-message", child: [
                      {name: "短信下行", path: "/downlogs"},
                      {name: "上行短信", path: "/uplogs"},
                      {name: "互动管理", path: "/autoreplies"},
                    ]
                  },
                  {
                    name: "API视频短信管理", icon: "el-icon-message", child: [
                      {name: "视频短信下行", path: "/video/logs"}
                    ]
                  },
                  {
                    name: "API国际短信管理", icon: "el-icon-message", child: [
                      {name: "国际短信下行", path: "/isms/logs"}
                    ]
                  },
                  {
                    name: "API语音短信管理", icon: "el-icon-message", child: [
                      {name: "语音短信下行", path: "/voice/logs"}
                    ]
                  },
                  {
                    name: "工单管理", icon: "el-icon-picture-outline", child: [
                      {name: "短信模板", path: "/templates"},
                      {name: "短信工单", path: "/jobs"},
                      {name: "视频短信模板", path: "/video/templates"},
                      {name: "视频短信工单", path: "/video/jobs"},
                      {name: "国际短信模板", path: "/isms/templates"},
                      {name: "国际短信工单", path: "/isms/jobs"},
                      {name: "语音短信模板", path: "/voice/templates"},
                      {name: "语音短信工单", path: "/voice/jobs"},
                    ]
                  },
                  {
                    name: "部门管理", icon: "el-icon-user", child: [
                      {name: "部门列表", path: "/customers"},
                      {name: "业务管理", path: "/businesses"},
                    ]
                  },
                  {
                    name: "运维工具", icon: "el-icon-star-on", child: [
                      {name: "敏感词", path: "/sensitives"},
                      {name: "黑名单", path: "/blacklist"},
                      {name: "名单管理", path: "/namelist"},
                      {name: "数据统计", path: "/summary"},
                      {name: "消费明细", path: "/dashboard/consume"},
                      {name: "统计面板", path: "/dashboard/summary"},
                    ]
                  },
                  {
                    name: "系统工具", icon: "el-icon-setting", child: [
                      {name: "下载管理", path: "/downloads"},
                      {name: "流控规则", path: "/rates"},
                      {name: "流控全局规则", path: "/rateglobal"},
                      {name: "错误码", path: "/config/errorcode"},
                    ]
                  }
                ];
              }

                if (this.$root.isOperation) {
                    this.removeMenus(["系统工具", "运营商管理", "部门管理", "敏感词", "黑名单", "名单管理", "统计面板", "报告推送", "互动管理"]);
                }

                if (this.$route.path === "/") {
                    this.$router.push("/summary");
                }
            } else {
                this.menus = [
                    {
                        name: "API短信管理", icon: "el-icon-message", child: [
                            {name: "短信下行", path: "/downlogs"},
                            {name: "上行短信", path: "/uplogs"},
                            {name: "互动管理", path: "/autoreplies"},
                        ]
                    },
                    {
                        name: "API视频短信管理", icon: "el-icon-message", child: [
                            {name: "视频短信下行", path: "/video/logs"},
                        ]
                    },
                    {
                        name: "API国际短信管理", icon: "el-icon-message", child: [
                            {name: "国际短信下行", path: "/isms/logs"},
                        ]
                    },
                    {
                        name: "API语音短信管理", icon: "el-icon-message", child: [
                            {name: "语音短信下行", path: "/voice/logs"}
                        ]
                    },
                    {
                        name: "工单管理", icon: "el-icon-message", child: [
                            { name: "短信模板", path: "/templates" },
                            { name: "短信工单", path: "/jobs" },
                            { name: "视频短信模板", path: "/video/templates" },
                            { name: "视频短信工单", path: "/video/jobs" },
                            { name: "国际短信模板", path: "/isms/templates" },
                            { name: "国际短信工单", path: "/isms/jobs" },
                            { name: "语音短信模板", path: "/voice/templates" },
                            {name: "语音短信工单", path: "/voice/jobs"},
                        ]
                    },
                    {name: "业务列表", icon: "el-icon-user", path: "/businesses"},
                    {
                        name: "运维工具", icon: "el-icon-star-on", child: this.$root.couldExport ? [
                            {name: "黑名单", path: "/blacklist"},
                            {name: "敏感词", path: "/sensitives"},
                            {name: "名单管理", path: "/namelist"},
                            {name: "数据统计", path: "/summary"},
                            {name: "下载管理", path: "/downloads"},
                        ] : [
                        {name: "黑名单", path: "/blacklist"},
                        {name: "敏感词", path: "/sensitives"},
                        {name: "名单管理", path: "/namelist"},
                        {name: "数据统计", path: "/summary"},
                      ]
                    },
                ];

                if (this.$root.role === 'BUSINESS') {
                  this.menus = this.menus.filter(item => item['name'] !== "业务列表");
                }

                if (this.$route.path === "/") {
                    this.$router.push("/downlogs");
                }
            }
        },
        methods: {
            dropdownClick(command) {
                if (command === "modifyPass") {
                    this.$router.push("/modifypass");
                } else if (command === "logout") {
                    this.logout();
                }
            },
            logout() {
                sessionStorage.removeItem("context");
                sessionStorage.removeItem("auth-token");
                this.$router.push("/login");
            },
            removeMenus(arr) {
                const menus = JSON.parse(JSON.stringify(this.menus));
                for (let i = menus.length - 1; i >= 0; i--) {
                    const item = menus[i];
                    if (arr.includes(item['name'])) {
                        menus.splice(i, 1);
                    } else if (item['child']) {
                        for (let j = item['child'].length - 1; j >= 0; j--) {
                            const subItem = item['child'][j];
                            if (arr.includes(subItem['name'])) {
                                item['child'].splice(j, 1);
                            }
                        }
                    }
                }
                this.menus = menus;
            }
        }
    }
</script>

<style scoped>
    .container {
        height: 100%;
    }

    .scale {
        transform: scale(0.75);
        transform-origin: left top;
        min-width: 1700px;
        min-height: 748px;
    }

    .el-aside {
        background-color: #2f4050;
    }

    >>> .el-menu {
        border-right: 0;
    }

    .el-main {
        height: 100%;
        background-color: #fff;
    }

    .el-backtop {
        position: absolute;
        top: 20px;
        right: 40px;
    }
</style>
<style>
    .el-aside .el-scrollbar__wrap, .el-main .el-scrollbar__wrap:first-child, .el-drawer__content .el-scrollbar__wrap {
        overflow-x: hidden !important;
    }

    .el-scrollbar__bar.is-horizontal {
        display: none;
    }

    .el-drawer__body {
        padding: 0 20px;
    }

    .el-drawer__content {
        height: calc(100vh - 120px);
    }

    .el-drawer__footer button {
        margin-bottom: 10px;
        width: 48%;
    }

    .el-drawer__footer button:last-child {
        float: right;
    }

    .el-page-header {
        margin-bottom: 20px;
    }

    .el-dialog__body {
        padding: 0 20px 30px 20px;
    }

    .el-pagination {
        margin: 10px 0;
    }

    .el-form-item.text {
        margin-bottom: 10px;
    }

    .el-form-item.text .el-form-item__content, .el-form-item.text .el-form-item__label {
        line-height: 25px;
    }

    .pull-right {
        float: right !important;
    }

    a {
        color: #606266;
        text-decoration: none;
    }

    .clear {
        clear: both;
    }

    .help-text {
        color: #909399;
        font-size: 13px;
        line-height: 30px;
        margin: 0;
    }

    dl {
        margin-top: 0;
        margin-bottom: 20px;
        overflow: hidden;
        line-height: 2.0;
    }

    .dl-horizontal dt {
        float: left;
        width: 110px;
        overflow: hidden;
        clear: left;
        text-align: right;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 600;
    }

    .dl-horizontal dd {
        margin-left: 120px;
        min-height: 32px;
    }
</style>
